import get from 'lodash/get';

export const createMapEntityToOptions = (config = {}) => {
  const {keyLabel = 'name', keyValue = '_id', secLabel = 'code'} = config;
  return item => {
    const value = get(item, keyValue);
    const label = get(item, keyLabel);
    const baseField = get(item, secLabel);
    return {value, label: label || baseField};
  };
};
